<!-- =========================================================================================
    File Name: FormValidationEvents.vue
    Description: Form validation on different events
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card code-toggler title="Change default event for form validation">

    <p>You can change default event when validation triggers using <code>data-vv-validate-on</code></p>
    <div class="mt-5">
      <form>
        <vs-input class="mt-5" data-vv-validate-on="blur" name="first_name" placeholder="First Name" v-model="first_name" v-validate="'required|alpha'"/>
        <span class="text-danger text-sm" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>

        <vs-input class="mt-5" data-vv-validate-on="blur" name="last_name" placeholder="Last Name" v-model="last_name" v-validate="'required|alpha'"/>
        <span class="text-danger text-sm" v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>

        <vs-button @click.prevent="submitForm" class="mt-5 block" type="filled">Submit</vs-button>
      </form>
    </div>

    <template slot="codeContainer">
      &lt;template&gt;
      &lt;form&gt;
      &lt;vs-input size=&quot;large&quot; v-validate=&quot;'required|alpha'&quot; placeholder=&quot;First Name&quot; name=&quot;first_name&quot; v-model=&quot;first_name&quot; class=&quot;mt-5&quot; data-vv-validate-on=&quot;blur&quot; /&gt;
      &lt;span class=&quot;text-danger text-sm&quot; v-show=&quot;errors.has('first_name')&quot;&gt;{{ '\{\{ errors.first(\'first_name\') \}\}' }}&lt;/span&gt;

      &lt;vs-input size=&quot;large&quot; v-validate=&quot;'required|alpha'&quot; placeholder=&quot;Last Name&quot; name=&quot;last_name&quot; v-model=&quot;last_name&quot; class=&quot;mt-5&quot; data-vv-validate-on=&quot;blur&quot; /&gt;
      &lt;span class=&quot;text-danger text-sm&quot; v-show=&quot;errors.has('last_name')&quot;&gt;{{ '\{\{ errors.first(\'last_name\') \}\}' }}&lt;/span&gt;

      &lt;vs-button type=&quot;filled&quot; @click.prevent=&quot;submitForm&quot; class=&quot;mt-5 block&quot;&gt;Submit&lt;/vs-button&gt;
      &lt;/form&gt;
      &lt;/template&gt;

      &lt;script&gt;
      export default {
      data() {
      return {
      first_name: &quot;&quot;,
      last_name: &quot;&quot;,
      }
      },
      methods: {
      submitForm() {
      this.$validator.validateAll().then(result =&gt; {
      if(result) {
      // if form have no errors
      alert(&quot;form submitted!&quot;);
      }else{
      // form have errors
      }
      })
      }
      },
      }
      &lt;/script&gt;
    </template>
  </vx-card>
</template>

<script>
  export default {
    data ()
    {
      return {
        first_name: '',
        last_name:  ''
      }
    },
    methods: {
      submitForm ()
      {
        this.$validator.validateAll().then(result => {
          if (result)
          {
            // if form have no errors
            alert('form submitted!')
          } else
          {
            // form have errors
          }
        })
      }
    }
  }
</script>
